import { combineReducers } from 'redux';
import agent from './agent';
import theme from './theme';
import session from './session';
import shopper from './shopper';
import plan from './plan';
import valid from './valid';
import values from './values';
import iframe from './iframe';
import telephony from './telephony';
import softphone from './softphone';
import form from './form';
import quote from './quote';
import validation from './validation';
import options from './options';
import modals from './modals';
import doctors from './doctors';
import script from './script';
import enrollment from './enrollment';
import labels from './labels';

export default () => combineReducers({
  agent,
  doctors,
  enrollment,
  iframe,
  labels,
  form,
  modals,
  options,
  plan,
  quote,
  script,
  session,
  shopper,
  softphone,
  telephony,
  theme,
  valid,
  validation,
  values,
});
